//  hidden === true时，当前项不在菜单栏中展示
export const data = [{
  label: '个人办公',
  icon: 'compass',
  path: '/',
  component: 'Layout',
  children: [{
    label: '工作台',
    icon: '',
    path: '/',
    name: 'workbench',
    component: 'workbench/index',
    meta: {
      title: '工作台'
    }
  }, {
    label: '信息列表',
    icon: '',
    path: '/newsList',
    name: 'newsList',
    component: 'workbench/newsList',
    meta: {
      isMenuOpens: '工作台',
      title: '信息列表'
    },
    hidden: true
  }, {
    label: '信息列表',
    icon: '',
    path: '/messageCenter',
    name: 'messageCenter',
    component: 'workbench/messageCenter',
    meta: {
      isMenuOpens: '消息中心',
      title: '信息列表'
    },
    hidden: true
  }, {
    label: '公司新闻',
    icon: '',
    path: '/newsDetial',
    name: 'newsDetial',
    component: 'workbench/newsDetial',
    meta: {
      isMenuOpens: '新闻管理',
      title: '公司新闻'
    },
    hidden: true
  }, {
    label: '个人中心',
    icon: '',
    path: '/mine',
    name: 'mine',
    component: 'workbench/mine',
    meta: {
      isMenuOpens: '工作台',
      title: '个人中心'
    },
    hidden: true
  }]
}, {
  label: '党办通知',
  icon: 'calendar',
  path: '/AccountingComputerizationNotice',
  component: 'Layout',
  children: [{
    label: '已发通知',
    icon: '',
    path: '/AccountingComputerizationNotice',
    name: 'AccountingComputerizationNotice',
    component: 'AccountingComputerizationNotice/index',
    meta: {
      isMenuOpens: '党办通知',
      title: '已发通知'
    }
  }, {
    label: '发送通知',
    icon: '',
    path: '/AccountingComputerizationNoticeDetial',
    name: 'AccountingComputerizationNoticeDetial',
    component: 'AccountingComputerizationNotice/detial',
    meta: {
      isMenuOpens: '党办通知',
      title: '发送通知'
    },
    hidden: true
  }, {
    label: '已收通知',
    icon: '',
    path: '/AccountingComputerizationNoticeReceived',
    name: 'AccountingComputerizationNoticeReceived',
    component: 'AccountingComputerizationNotice/received',
    meta: {
      isMenuOpens: '党办通知',
      title: '已收通知'
    }
  }, {
    label: '已回通知',
    icon: '',
    path: '/AccountingComputerizationNoticeReplied',
    name: 'AccountingComputerizationNoticeReplied',
    component: 'AccountingComputerizationNotice/replied',
    meta: {
      isMenuOpens: '党办通知',
      title: '已回通知'
    }
  }, {
    label: '回复',
    icon: '',
    path: '/AccountingComputerizationNoticeReply',
    name: 'AccountingComputerizationNoticeReply',
    component: 'AccountingComputerizationNotice/reply',
    meta: {
      isMenuOpens: '党办通知',
      title: '回复'
    }
  }]
}, {
  label: '人事管理',
  icon: 'user',
  path: '/roster',
  component: 'Layout',
  children: [{
    label: '人员花名册',
    icon: '',
    path: '/roster',
    name: 'roster',
    component: 'PersonnelManagement/roster',
    meta: {
      isMenuOpens: '人事管理',
      title: '人员花名册'
    },

  }, {
    label: '合同到期人员',
    icon: '',
    path: '/expireList',
    name: 'expireList',
    component: 'PersonnelManagement/expireList',
    meta: {
      isMenuOpens: '人事管理',
      title: '到期提醒'
    }
  }, {
    label: '详情页',
    icon: '',
    path: '/PersonnelDetails',
    name: 'PersonnelDetails',
    component: 'PersonnelManagement/PersonnelDetails',
    hidden: true,
    meta: {
      isMenuOpens: '人事管理',
      title: '人员详细信息'
    }
  }, {
    label: '新建花名册信息',
    icon: '',
    path: '/addPersonnel',
    name: 'addPersonnel',
    component: 'PersonnelManagement/add',
    hidden: true,
    meta: {
      isMenuOpens: '人事管理',
      title: '新建花名册信息'
    }
  }, {
    label: '历史查询',
    icon: '',
    path: '/AdvancedQuery',
    name: 'AdvancedQuery',
    component: 'PersonnelManagement/AdvancedQuery',
    hidden: true,
    meta: {
      isMenuOpens: '人事管理',
      title: '历史查询'
    }
  }]
}, {
  label: '固定资产管理',
  icon: 'dollar',
  path: '/procurement',
  component: 'Layout',
  children: [{
      label: '固定资产购置申请表',
      icon: '',
      path: '/procurement',
      name: 'procurement',
      component: 'FixedAssets/procurement',
      meta: {
        isMenuOpens: '固定资产管理',
        title: '固定资产购置申请表'
      }
    },
    //  {
    //   label: '草稿箱',
    //   icon: '',
    //   path: '/drafts',
    //   name: 'drafts',
    //   component: 'FixedAssets/drafts',
    //   meta: {
    //     isMenuOpens: '固定资产管理',
    //     title: '草稿箱'
    //   }
    // }, 
    {
      label: '固定资产购置申请',
      icon: '',
      path: '/proDetial',
      name: 'proDetial',
      component: 'FixedAssets/proDetial',
      hidden: true,
      meta: {
        isMenuOpens: '固定资产管理',
        title: '固定资产购置申请'
      }
    }, {
      label: '固定资产处置审批表',
      icon: '',
      path: '/disposition',
      name: 'disposition',
      component: 'FixedAssets/disposition',
      meta: {
        isMenuOpens: '固定资产管理',
        title: '固定资产处置审批表'
      }
    },
    //  {
    //   label: '草稿箱',
    //   icon: '',
    //   path: '/disDrafts',
    //   name: 'disDrafts',
    //   component: 'FixedAssets/disDrafts',
    //   meta: {
    //     isMenuOpens: '固定资产管理',
    //     title: '草稿箱'
    //   }
    // }, 
    {
      label: '固定资产处置',
      icon: '',
      path: '/disDetial',
      name: 'disDetial',
      component: 'FixedAssets/disDetial',
      meta: {
        isMenuOpens: '固定资产管理',
        title: '固定资产处置'
      },
      hidden: true
    }
  ]
}, {
  label: '系统管理',
  icon: 'windows',
  path: '/system',
  component: 'Layout',
  children: [{
    label: '组织机构',
    icon: '',
    path: '/InstitutionalFramework',
    name: 'InstitutionalFramework',
    component: 'system/InstitutionalFramework',
    meta: {
      isMenuOpens: '系统管理',
      title: '组织机构'
    }
  }, {
    label: '创建机构',
    icon: '',
    path: '/addInstitutionalFramework',
    name: 'addInstitutionalFramework',
    component: 'system/addInstitutionalFramework',
    meta: {
      isMenuOpens: '组织机构管理',
      title: '创建机构'
    },
    hidden: true
  }, {
    label: '组织机构管理列表',
    icon: '',
    path: '/userList',
    name: 'userList',
    component: 'system/userList',
    meta: {
      isMenuOpens: '组织机构管理',
      title: '组织机构管理列表'
    }
  }, {
    label: '组织机构管理列表',
    icon: '',
    path: '/adduser',
    name: 'adduser',
    component: 'system/adduser',
    meta: {
      isMenuOpens: '组织机构管理',
      title: '组织机构管理列表'
    },
    hidden: true
  }, 
  {
    label: '权限管理',
    icon: '',
    path: '/role',
    name: 'role',
    component: 'system/role',
    meta: {
      isMenuOpens: '权限管理',
      title: '权限列表'
    }
  },
  {
    label: '通知管理',
    icon: '',
    path: '/InformManagement',
    name: 'InformManagement',
    component: 'system/InformManagement',
    meta: {
      isMenuOpens: '权限管理',
      title: '通知管理'
    }
  },
   {
    label: '审批流管理列表',
    icon: '',
    path: '/activitiList',
    name: 'activitiList',
    component: 'system/activitiList/index',
    meta: {
      isMenuOpens: '系统管理',
      title: '审批流列表'
    }
  }, {
    label: '审批流管理列表',
    icon: '',
    path: '/activitiDetails',
    name: 'activitiDetails',
    component: 'system/activitiList/activitiDetails',
    meta: {
      isMenuOpens: '系统管理',
      title: '审批流列表'
    },
    hidden: true
  }, {
    label: '审批流管理列表',
    icon: '',
    path: '/createActiviti',
    name: 'createActiviti',
    component: 'system/activitiList/createActiviti',
    meta: {
      isMenuOpens: '系统管理',
      title: '审批流列表',
      createActiviti: '1'
    },
    hidden: true
  }, {
    label: '我的任务',
    icon: '',
    path: '/myMission',
    name: 'newsList',
    component: 'myMission/index',
    meta: {
      isMenuOpens: '工作台',
      title: '我的任务'
    },
    hidden: true
  }]
}]



// WEBPACK FOOTER //
// ./src/layout/menu2.js